export const cardShadowStyle = {
  boxShadow: 'rgba(83, 83, 83, 0.08) 0px 1px 6px 0px',
  borderColor: '#DDDDDD',
};
